"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../data/utils");
function sameLink(left, right) {
    return (left.linkTypeId === right.linkTypeId &&
        left.sourceId === right.sourceId &&
        left.targetId === right.targetId);
}
exports.sameLink = sameLink;
function hashLink(link) {
    var linkTypeId = link.linkTypeId, sourceId = link.sourceId, targetId = link.targetId;
    var hash = utils_1.hashFnv32a(linkTypeId);
    hash = hash * 31 + utils_1.hashFnv32a(sourceId);
    hash = hash * 31 + utils_1.hashFnv32a(targetId);
    return hash;
}
exports.hashLink = hashLink;
function sameElement(left, right) {
    return (left.id === right.id &&
        isArraysEqual(left.types, right.types) &&
        isLocalizedStringsEqual(left.label.values, right.label.values) &&
        left.image === right.image &&
        isPropertiesEqual(left.properties, right.properties) &&
        ((!left.sources && !right.sources) ||
            (left.sources && right.sources && isArraysEqual(left.sources, right.sources))));
}
exports.sameElement = sameElement;
function isArraysEqual(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (var i = 0; i < left.length; i++) {
        if (left[i] !== left[i]) {
            return false;
        }
    }
    return true;
}
function isLocalizedStringsEqual(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (var i = 0; i < left.length; i++) {
        var leftValue = left[i];
        var rightValue = right[i];
        if (leftValue.text !== rightValue.text || leftValue.lang !== rightValue.lang) {
            return false;
        }
    }
    return true;
}
function isPropertiesEqual(left, right) {
    if (Object.keys(left).length !== Object.keys(right).length) {
        return false;
    }
    for (var key in left.properties) {
        if (left.properties.hasOwnProperty(key)) {
            var leftProperty = left[key];
            var rightProperty = right[key];
            if (!rightProperty || !isLocalizedStringsEqual(leftProperty.values, rightProperty.values)) {
                return false;
            }
        }
    }
    return true;
}
